import React, { FC } from 'react';
import { Box, Heading, Text } from '@bechtel/gds';
import { useAppUser, useDate } from '@bechtel/client-common';
import { Trans } from '@lingui/macro';
import { find } from 'lodash';

export const CurrentWeek: FC = () => {
  const { user } = useAppUser();
  const { formatISODate } = useDate();
  const currentProjectWeek = find(user?.project?.projectConfiguration?.projectWeeks, (projectWeek) =>
    projectWeek?.isCurrent ? true : false
  );
  return (
    <Box flexGrow={{ sm: 1 }} alignItems={{ sm: 'center' }}>
      <Heading size="600" color="grey.1000" weight="600">
        <Trans>Current Week</Trans> {currentProjectWeek?.weekNumber}
      </Heading>
      &nbsp;&nbsp;
      <Text size="600" color="grey.600">
        {formatISODate(currentProjectWeek?.startDate, 'MMM dd')} -{' '}
        {formatISODate(currentProjectWeek?.endDate, 'MMM dd')}
      </Text>
    </Box>
  );
};
